import { useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import { XCircle, CheckCircle2, Loader2, ChevronLeft } from "lucide-react"
import api from "@/api/kuizy"

const fade = { initial:{opacity:0,y:12}, animate:{opacity:1,y:0}, transition:{duration:.25} }

export default function DeclinePage() {
  const { type, token } = useParams()
  const nav = useNavigate()
  const [reason, setReason] = useState("")
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState("")

  const isAdmin = String(type || "").toLowerCase() === "a"
  const isLearner = String(type || "").toLowerCase() === "l"
  const backHref = isAdmin ? "/login" : "/learn/login"
  const KuizyHref = "https://www.kuizy.ai/"
  const title = isAdmin ? "ยืนยันการปฏิเสธคำเชิญสำหรับผู้ดูแล" : "ยืนยันการปฏิเสธคำเชิญสำหรับผู้เรียน"
  const subtitle =  "ระบบจะดำเนินการยกเลิกคำเชิญครั้งนี้ครับ ขออภัยหากการติดต่อครั้งนี้ก่อให้เกิดความไม่สะดวก และขอขอบพระคุณเป็นอย่างยิ่งที่สละเวลาในการพิจารณา"

  const submit = async () => {
    if (!token || (!isAdmin && !isLearner)) {
      setError("ลิงก์ไม่ถูกต้อง"); return
    }
    setLoading(true)
    setError("")
    try {
      const url = isAdmin ? `/decline/a/${token}` : `/decline/l/${token}`
      await api.post(url, { reason })
      setDone(true)
    } catch (e) {
      const msg = e?.response?.data?.detail || e?.message || "ไม่สามารถดำเนินการได้"
      setError(String(msg))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-gray-50 to-white flex items-center justify-center p-4">
      <motion.div {...fade} className="w-full max-w-xl bg-white border border-gray-200 rounded-2xl shadow-xl">
        <div className="px-6 py-5 border-b border-gray-100 flex items-center gap-3">
          <button onClick={() => nav(backHref)} className="inline-flex items-center text-gray-500 hover:text-gray-700">
            <ChevronLeft className="w-5 h-5" />
          </button>
          <div className="font-semibold text-gray-900">{title}</div>
        </div>

        {!done ? (
          <div className="px-6 py-6 space-y-4">
            <div className="flex items-start gap-3">
              <XCircle className="w-6 h-6 text-rose-600 mt-0.5" />
              <div>
                <div className="text-gray-900 font-semibold">ต้องการปฏิเสธคำเชิญหรือไม่</div>
                <div className="text-gray-600 text-sm">{subtitle}</div>
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-sm text-gray-700">เหตุผล (ไม่บังคับ)</label>
              <textarea
                value={reason}
                onChange={e => setReason(e.target.value)}
                rows={4}
                className="w-full rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary/50 p-3"
                placeholder="ระบุเหตุผลสั้น ๆ เพื่อให้องค์กรรับทราบ"
              />
            </div>

            {error ? (
              <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-lg p-2.5">
                {error}
              </div>
            ) : null}

            <div className="flex items-center justify-between pt-2">
              <button
                onClick={() => nav(backHref)}
                className="px-4 py-2 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-50"
                disabled={loading}
              >
                ยกเลิก
              </button>
              <button
                onClick={submit}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-rose-600 text-white hover:bg-rose-700 disabled:opacity-60"
                disabled={loading}
              >
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <XCircle className="w-4 h-4" />}
                ยืนยันการปฏิเสธ
              </button>
            </div>
          </div>
        ) : (
          <div className="px-6 py-10 text-center space-y-3">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-emerald-50">
              <CheckCircle2 className="w-8 h-8 text-emerald-600" />
            </div>
            <div className="text-lg font-semibold text-gray-900">ดำเนินการเรียบร้อย</div>
            <div className="text-gray-600 text-sm">
              {isAdmin ? "ระบบได้ยกเลิกคำเชิญสำหรับผู้ดูแลแล้ว ขอขอบพระคุณเป็นอย่างยิ่งที่สละเวลา" : "ระบบได้ยกเลิกคำเชิญแล้ว ขอขอบพระคุณเป็นอย่างยิ่งที่สละเวลา"}
            </div>
            <div className="pt-2">
               <a href={KuizyHref}
               
                className="px-5 py-2.5 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-50"
              >
                ไปเยี่ยมชมเว็บไซต์ Kuizy
              </a>
            </div>
          </div>
        )}
      </motion.div>
    </div>
  )
}
